import { render, staticRenderFns } from "./Ghold.vue?vue&type=template&id=51c7dd76&"
import script from "./Ghold.vue?vue&type=script&lang=js&"
export * from "./Ghold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports